<template>
  <div v-if="currentChecklist && currentComponent">
    <components :is="currentComponent" :currentChecklist="currentChecklist" />
  </div>
</template>

<script>
import QcmEdit from '../components/qcm/Edit.vue';
import QrmEdit from '../components/qrm/Edit.vue';
import QvfEdit from '../components/qvf/Edit.vue';
import QnEdit from '../components/qn/Edit.vue';
import QcEdit from '../components/qc/Edit.vue';
import QlEdit from '../components/ql/Edit.vue';
import QrsEdit from '../components/qrs/Edit.vue';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      currentComponent: null,
    };
  },
  watch: {
    '$route.params.type': {
      handler: function (value) {
        switch (value) {
          case 'qcm':
            this.currentComponent = QcmEdit;
            break;
          case 'qrm':
            this.currentComponent = QrmEdit;
            break;
          case 'qvf':
            this.currentComponent = QvfEdit;
            break;
          case 'qrn':
            this.currentComponent = QnEdit;
            break;
          case 'qrc':
            this.currentComponent = QcEdit;
            break;
          case 'qrl':
            this.currentComponent = QlEdit;
            break;
          case 'qrs':
            this.currentComponent = QrsEdit;
            break;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapGetters('checklist', ['currentChecklist']),
  },
};
</script>

<style scoped></style>
